import { User } from '@elio/emanager-front/auth/model';
import { createAction, props } from '@ngrx/store';
import { HqProfessionalView } from '../../model/src';

const upsertHqProfessionalPush = createAction(
  '[HqProfessional push Effect] upsert headquarters professional after PUSH',
  props<{ hqProfessionalView: HqProfessionalView }>()
);

const hqProfessionalLeaveHeadquarterPush = createAction(
  '[HqProfessional push Effect] headquarters professional leave headquarters PUSH',
  props<{ hqProfessionalId: number }>()
);

const leaveUniqueHeadquarter = createAction('[Professional push Effect] professional leaves his unique headquarter');

const leaveOneHeadquarter = createAction(
  '[Professional push Effect] professional leaves one of his headquarters',
  props<{ user: User; hqId: number }>()
);

export const HqProfessionalPushActions = {
  upsertHqProfessionalPush,
  hqProfessionalLeaveHeadquarterPush,
  leaveUniqueHeadquarter,
  leaveOneHeadquarter,
};
